var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._m(0),_c('div',{staticClass:"flex-line",staticStyle:{"flex-wrap":"wrap"}},_vm._l((_vm.list),function(item){return _c('vehicle-type-item',{key:item.idx,staticClass:"brandItem",attrs:{"data":item}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"title1"},[_vm._v("车辆类型分布")])])
}]

export { render, staticRenderFns }